export enum B2bQuotationEngineWorkspaceCapabilityAccessOperation {
    create = "9951c1a9-7e63-43e1-8b06-a829912c2d5e",
    read = "ef88cea0-d203-4ac8-9528-102ee9284c58",
    update = "d35366ae-4252-4c42-a9bd-365e9d3ade5e",
    delete = "156bfc4e-1737-455a-bca2-e330feea6bc6",
}
